import React, {Fragment} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';
import LaddaButton, {SLIDE_UP} from "react-ladda";
import {ResponsiveHelper, ResponsiveSize} from "../utils/ResponsiveHelper";
import {Col, Row} from "reactstrap";
import {ViewConfig} from "../views/ViewConfig";

const FILTER_DELAY_MILLIS = 333;


export default class DataTableComponent extends React.Component {

  constructor(props) {
    super(props);
    if (props.onRef) {
      props.onRef(this);
    }

    this.enableSortByDefault = true;
    this.keyColumnDataField = props.tableColumnConfig[0].dataField;

    this.options = DataTableComponent.getStandardOptions(this.props);

    this.options.paginationShowsTotal = DataTableComponent.getPaginationTotalFunction();
    this.options.toolBar = DataTableComponent.getToolbarFunction(this.props.hideToolBar, this.props.createSearchGroup);
    this.options.btnGroup = DataTableComponent.getButtonGroupFunction(this.props.createCustomButtonGroup);

    this.state = {
      buttonStates: {}
    };

    this.getButtonState = this.getButtonState.bind(this);
  }

  static getStandardOptions = function (props) {
    return {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 5,
      sizePerPage: 10,
      hidePageListOnlyOnePage: true,
      clearSearch: false,
      alwaysShowAllBtns: false,
      withFirstAndLast: true,
      expandBy: "column",
      onRowClick: props.onRowClick,
      onFilterChange: props.onFilterChange
    };
  };

  getButtonState(key, id) {
    return this.state.buttonStates
      && this.state.buttonStates[key]
      && this.state.buttonStates[key].indexOf(id) >= 0;
  }

  setButtonState(key, id, value) {
    let buttonStates = this.state.buttonStates || {};
    let buttonStatesForKey = buttonStates[key] || [];
    let index = buttonStatesForKey.indexOf(id);

    if (value === true) {
      if (index < 0)
        buttonStatesForKey.push(id);
    } else {
      buttonStatesForKey.splice(index, 1);
    }
    buttonStates[key] = buttonStatesForKey;
    this.setState({
      buttonStates: buttonStates
    });
  }

  getData() {
    if (!Array.isArray(this.props.tableData)) {
      console.log("Invalid tableData set: " + JSON.stringify(this.props.tableData));
      return [];
    }
    return this.props.tableData;
  }

  render() {
    return <BootstrapTable
      className={"sfx-data-table"}
      ref={'table'}
      striped={true}
      hover={false}
      pagination={this.props.pagination === undefined ? true : this.props.pagination}
      condensed
      search={this.props.search === undefined ? true : this.props.search}
      version="4"
      data={this.getData()}
      options={this.options}
      selectRow={this.onSelectRow}
      expandableRow={this.props.isExpandableRow || undefined}
      expandComponent={this.props.getExpandableComponent || undefined}
      exportCSV={this.props.exportCSV}
    >
      {
        this.props.tableColumnConfig.map((column, index) => {
          return DataTableComponent.createColumn(column, index, this);
        })
      }
    </BootstrapTable>;

  }

  static createColumn = function (columnConfig, columnIndex, component) {

    let columnKey = columnConfig.dataField;
    let hidden = columnConfig.hidden;
    if (typeof hidden === "string") {
      hidden = ResponsiveHelper.isSmallerThanOrEquals(window.responsiveSize, hidden);
    }

    return <TableHeaderColumn
      key={columnKey}
      dataField={columnKey}
      isKey={columnIndex === 0}
      width={columnConfig.width}
      dataAlign={columnConfig.align}
      hidden={hidden}
      dataSort={columnConfig.sort === undefined ? component.enableSortByDefault : columnConfig.sort}
      filter={DataTableComponent.createFilter(columnIndex, columnConfig, component)}
      dataFormat={DataTableComponent.createDataFormat(columnIndex, columnConfig, component)}

      expandable={DataTableComponent.isExpandable(columnConfig)}
    >
      {columnConfig.header}
    </TableHeaderColumn>
  };

  static isExpandable(columnConfig) {

    return columnConfig.type !== "button" &&
      columnConfig.type !== "toggleButton" &&
      columnConfig.type !== "multiButton";
  }

  static createFilter = function (columnIndex, columnConfig, component) {
    if (columnConfig.filter !== undefined) {
      let defaultValue = component.props.tableFilters && component.props.tableFilters[columnConfig.dataField]
        ? component.props.tableFilters[columnConfig.dataField].value
        : "";

      if (columnConfig.filter === "txteq")
        return {
          type: "TextFilter",
          delay: FILTER_DELAY_MILLIS,
          defaultValue: defaultValue,
          condition: 'eq'
        };
      else
        return {
          type: "TextFilter",
          delay: FILTER_DELAY_MILLIS,
          defaultValue: defaultValue
        };
    }
    return undefined;
  };

  static createDataFormat = function (columnIndex, columnConfig, component) {
    if (columnConfig.type === undefined) return DataTableComponent.createCell(columnIndex, columnConfig);
    else if (columnConfig.type === "custom") return DataTableComponent.createCustomCell(columnIndex, columnConfig, component);
    else if (columnConfig.type === "boolean") return DataTableComponent.createBooleanCell(columnIndex, columnConfig);
    else if (columnConfig.type === "button") return DataTableComponent.createButtonCell(columnIndex, columnConfig, component.getButtonState, component.props.onButtonClick);
    else if (columnConfig.type === "multiButton") return DataTableComponent.createMultiButtonCell(columnIndex, columnConfig, component.getButtonState, component.props.onButtonClick);
    else if (columnConfig.type === "toggleButton") return DataTableComponent.createToggleButtonCell(columnIndex, columnConfig, component.getButtonState, component.props.onButtonClick);
    return DataTableComponent.createCell(columnIndex, columnConfig);
  };

  static createCell = function (columnIndex, columnConfig) {
    return (cell_value, row) => {
      if (typeof (cell_value) !== "string") {
        cell_value = JSON.stringify(cell_value);
      }
      return <span title={cell_value}>
        {cell_value}
      </span>;
    }
  };

  static createCustomCell(columnIndex, columnConfig, component) {
    if (component.props.createCustomCell) {
      return (cell_value, row) => {
        return component.props.createCustomCell(cell_value, row, columnConfig);
      };
    } else {
      return DataTableComponent.createCell(columnIndex, columnConfig);
    }
  }

  static createBooleanCell = function (columnIndex, columnConfig) {
    let columnKey = columnConfig.dataField;
    let trueFunction;
    if (columnConfig.isTrue) {
      trueFunction = columnConfig.isTrue;
    } else {
      let trueValue = columnConfig.trueValue || true;
      trueFunction = (val) => {
        return val === trueValue
      }
    }


    return (cell_value, row) => {
      let isTrue = trueFunction(row[columnKey]);
      return <i className={isTrue
        ? "fa fa-check icons font-2xl"
        : "fa fa-close icons font-2xl"}
                style={isTrue
                  ? {color: "green"}
                  : {color: "red"}}

      />;
    }
  };

  static createButtonCell = function (columnIndex, columnConfig, getButtonState, onButtonClick) {
    let columnKey = columnConfig.dataField;
    return (cellValue, row) => {
      let loading = getButtonState(columnKey, row[this.keyColumnDataField]);
      let className = "btn btn-primary btn-ladda btn-sm sfx-datatable-btn";
      let buttonText = columnConfig.buttonText || "Button";
      if (columnConfig.getButtonText) {
        buttonText = columnConfig.getButtonText(row);
      }

      return <LaddaButton
        data-color="blue"
        data-style={SLIDE_UP}
        size={"xs"}
        className={className}
        loading={loading}
        onClick={() => {
          if (onButtonClick) {
            onButtonClick(columnKey, row)
          }
        }}
      >
        {buttonText}
      </LaddaButton>
    }
  };

  static createMultiButtonCell = function (columnIndex, columnConfig, getButtonState, onButtonClick) {
    return (cellValue, row) => {
      let className = "btn btn-info btn-ladda btn-sm";

      return <Fragment>
        {
          columnConfig.buttonKey.map((singleButtonKey, index) => {
            let buttonText = columnConfig.buttonText[index] || "Button";
            let columnKey = singleButtonKey;
            let loading = getButtonState(columnKey, row[this.keyColumnDataField]);

            return <Fragment key={index}>
              <LaddaButton
                data-color="blue"
                data-style={SLIDE_UP}
                size={"sm"}
                className={className}
                loading={loading}
                onClick={() => {
                  if (onButtonClick) {
                    onButtonClick(columnKey, row)
                  }
                }}
              >
                {buttonText}
              </LaddaButton>
              &nbsp;
            </Fragment>
          })
        }
      </Fragment>
    }
  };

  static createToggleButtonCell = function (columnIndex, columnConfig, getButtonState, onButtonClick) {
    let columnKey = columnConfig.dataField;
    return (cellValue, row) => {
      let buttonIsActive = row[columnKey] === true;
      let loading = getButtonState(columnKey, row[this.keyColumnDataField]);
      let className = buttonIsActive
        ? "btn btn-info btn-ladda btn-sm"
        : "btn btn-info btn-ladda btn-sm btn-outline-primary";
      let buttonText = (buttonIsActive && columnConfig.buttonTextTrue)
        || (!buttonIsActive && columnConfig.buttonTextFalse)
        || columnConfig.buttonText || "ButtonText";

      return <LaddaButton
        data-color="blue"
        data-style={SLIDE_UP}
        size={"sm"}
        className={className}
        loading={loading}
        onClick={() => {
          if (onButtonClick) {
            onButtonClick(columnKey, row)
          }
        }}
      >
        {buttonText}
      </LaddaButton>
    }
  };

  static getPaginationTotalFunction = function () {
    return (from, to, total) => {
      if (total === 0) return <Fragment/>;
      else return <div style={{color: "var(--riaOrange)"}}>Showing {from} to {to} of {total}</div>
    }
  };

  static getToolbarFunction = function (hideToolBar, createSearchGroup) {
    if (hideToolBar) {
      return () => {
        return <Fragment/>
      };
    } else return (props) => {
      let className = "";
      if (ResponsiveHelper.isLargerThan(window.responsiveSize, ResponsiveSize.SM)) {
        return (
          <Fragment>
            <Col md={12} style={{display: "flex"}}>
              <div className={className}>
                {props.components.btnGroup}
              </div>
              <div style={{flex: "1"}}>
                {
                  createSearchGroup
                    ? createSearchGroup()
                    : <Row {...ViewConfig.SEARCH_GROUP_ROW_PROPS}>
                      <Col {...ViewConfig.SEARCH_BOX_PROPS}>
                        {props.components.searchPanel}
                      </Col>
                    </Row>
                }
              </div>
            </Col>
          </Fragment>
        );
      } else {
        className = "side-panel";
        return (
          <Fragment>
            <Col md={6} lg={8} className={className}>
              {props.components.btnGroup}
            </Col>
            <Col md={6} lg={4}>
              {createSearchGroup ? createSearchGroup() : props.components.searchPanel}
            </Col>
          </Fragment>
        );
      }
    }
  };

  static getButtonGroupFunction = function (createCustomButtonGroup) {
    return (props) => {
      return <Fragment>
        {createCustomButtonGroup && createCustomButtonGroup()}
        {props.exportCSVBtn}
      </Fragment>
    };
  }
}
